const highlightSearchterm = (searchStringList, resultString) => {
  const sortedSearchStringList = searchStringList.map((t) => t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")).sort((a, b) => b.length - a.length);
  return resultString.split(/\s/).map((word) => {
    const filteredSearchString = sortedSearchStringList.filter(
      (input) => new RegExp(input, "i").test(word)
    );
    if (filteredSearchString.length === 0) {
      return word;
    }
    return word.replace(
      new RegExp(filteredSearchString[0], "i"),
      (input) => `<strong>${input}</strong>`
    );
  }).join(" ");
};
const getMatchCount = (label, tokens) => {
  const normalizedLabel = label.toLowerCase().replace(/\s+/g, "");
  return tokens.reduce((count, token) => count + (normalizedLabel.includes(token) ? 1 : 0), 0);
};
const filteredOptions = (value, options, groupEntries = false) => {
  const trimmedInput = value.trim();
  let inputTokens = trimmedInput.toLowerCase().split(/\s+/).filter((s) => s.length > 0);
  if (inputTokens.length === 0)
    return options;
  let filterOptions = options;
  let foundGroup = false;
  if (groupEntries) {
    const matchingGroups = options.filter((option) => {
      const groupName = (option.groupName || "").toLowerCase();
      const compressedLabel = groupName.replace(/\s+/g, "");
      return inputTokens.includes(groupName) || inputTokens.includes(compressedLabel);
    });
    if ((matchingGroups == null ? void 0 : matchingGroups.length) > 0) {
      foundGroup = true;
      filterOptions = matchingGroups;
      inputTokens = inputTokens.filter(
        (token) => {
          var _a;
          return token !== ((_a = matchingGroups[0].groupName) == null ? void 0 : _a.toLowerCase());
        }
      );
    }
  }
  if (inputTokens.length === 0)
    return filterOptions;
  return filterOptions.filter((option) => {
    const groupName = !foundGroup ? (option.groupName || "").toLowerCase() : "";
    const normalizedLabel = `${groupName} ${option.label}`.toLowerCase();
    const compressedLabel = normalizedLabel.replace(/\s+/g, "");
    return inputTokens.some((token) => normalizedLabel.includes(token)) || inputTokens.some((token) => compressedLabel.includes(token));
  }).sort((a, b) => {
    var _a, _b, _c, _d;
    if (groupEntries && a.groupName && b.groupName) {
      if (((_a = a.groupName) == null ? void 0 : _a.toLowerCase()) < ((_b = b.groupName) == null ? void 0 : _b.toLowerCase()))
        return -1;
      if (((_c = a.groupName) == null ? void 0 : _c.toLowerCase()) > ((_d = b.groupName) == null ? void 0 : _d.toLowerCase()))
        return 1;
    }
    const aExactMatch = a.label.toLowerCase() === trimmedInput.toLowerCase();
    const bExactMatch = b.label.toLowerCase() === trimmedInput.toLowerCase();
    if (aExactMatch)
      return -1;
    if (bExactMatch)
      return 1;
    const aMatchCount = getMatchCount(a.label, inputTokens);
    const bMatchCount = getMatchCount(b.label, inputTokens);
    return bMatchCount - aMatchCount;
  }).map((item) => ({
    ...item,
    label: highlightSearchterm(inputTokens, item.label)
  }));
};
export {
  filteredOptions,
  getMatchCount,
  highlightSearchterm
};
